import React from "react";
import {TopMenuAdmin} from "@/components/layouts/top-menu-admin";
import {UserMenu} from "@/components/layouts/user-menu";
import NotificationBell from "@/components/NotificationBell";
import {useTranslation} from "react-i18next";
import Icon from "@/components/Icon";
import {OPEN_PALETTE_EVENT} from "@/components/CommandPalette";
import {isMacOS} from "@/lib/platform";

export function Navbar({className, ...props}) {
    const {t} = useTranslation();
    // Товчлуур нь Windows/Linux дээр Ctrl+K-гаар ажилладаг — тэмдэглэгээ нь ч
    // тэр платформынхоо товчийг харуулна.
    const shortcut = isMacOS() ? "⌘K" : "Ctrl K";
    return (
        <>
            {/*{*/}
            {/*    isInstAdmin ? <TopMenuAdmin/> : <TopMenuSimulate/>*/}
            {/*}*/}

            <TopMenuAdmin/>

            {/*<TopMenuAdmin/>*/}
            <div className={'flex flex-1 items-center justify-between space-x-2 md:justify-end sm:justify-end'}>
                {/*{*/}
                {/*    auth.user.isadmin == 1 && <InstitutionDropdown/>*/}
                {/*}*/}
                <button
                    type={'button'}
                    onClick={() => window.dispatchEvent(new Event(OPEN_PALETTE_EVENT))}
                    className={'hidden items-center gap-2 rounded-full border border-slate-200 bg-white/80 px-3 py-1 text-xs text-slate-500 transition-colors hover:border-slate-300 hover:bg-white md:flex'}
                >
                    <Icon name={'Search'} size={14}/>
                    <span>{t('search')}</span>
                    <kbd className={'rounded border border-slate-200 bg-slate-50 px-1 text-[10px]'}>{shortcut}</kbd>
                </button>
                <NotificationBell/>
                <UserMenu/>
            </div>
        </>

    );
}
